/* Sell With Roxy: behaviour + motion */
var SWR = (function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function paint(n) {
    if (typeof n === 'undefined') n = window.SWR_CART_COUNT || 0;
    window.SWR_CART_COUNT = n;
    document.querySelectorAll('.cartcount').forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? 'inline-flex' : 'none';
    });
  }
  function addToCart(id, qty, done) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js');
    }).then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count); if (done) done(null); })
      .catch(function (e) { if (done) done(e); });
  }

  var pars = [];
  function collectParallax(scope) {
    pars = [].slice.call((scope || document).querySelectorAll('[data-par]'));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || 0;
      var doc = document.documentElement.scrollHeight - window.innerHeight;
      var bar = document.querySelector('.sprog');
      if (bar) bar.style.width = (doc > 0 ? (y / doc) * 100 : 0) + '%';
      var hdr = document.querySelector('.hdr');
      if (hdr) hdr.classList.toggle('shrunk', y > 30);
      if (!reduce && window.innerWidth >= 900) {
        var vh = window.innerHeight;
        pars.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var mid = r.top + r.height / 2 - vh / 2;
          el.style.transform = 'translate3d(0,' + (-mid * parseFloat(el.dataset.par)).toFixed(1) + 'px,0)';
        });
      } else {
        pars.forEach(function (el) { el.style.transform = ''; });
      }
      ticking = false;
    });
  }

  var io = null;
  function countUp(el) {
    var target = parseFloat(el.dataset.count);
    var dec = parseInt(el.dataset.dec || '0', 10);
    var suf = el.dataset.suffix || '';
    if (reduce) { el.textContent = target.toFixed(dec) + suf; return; }
    var start = null, dur = 1400;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initReveal(scope) {
    scope = scope || document;
    var items = scope.querySelectorAll('.rv, .wipe, [data-count]');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); el.classList.add('shown'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('in');
          if (el.classList.contains('wipe')) el.classList.add('shown');
          if (el.dataset.count) countUp(el);
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    }
    var groups = {};
    items.forEach(function (el) {
      var key = Math.round(el.getBoundingClientRect().top / 120);
      groups[key] = (groups[key] || 0) + 1;
      el.style.transitionDelay = Math.min(groups[key] - 1, 4) * 80 + 'ms';
      io.observe(el);
    });
  }

  function bind(scope) {
    scope = scope || document;
    var hdr = document.querySelector('.hdr');
    var burger = document.getElementById('burger');
    if (burger && hdr && !burger.dataset.bound) {
      burger.dataset.bound = '1';
      burger.addEventListener('click', function () {
        var open = hdr.classList.toggle('open');
        burger.textContent = open ? '\u2715' : '\u2630';
        burger.setAttribute('aria-expanded', open);
      });
    }
    scope.querySelectorAll('.acc').forEach(function (acc) {
      if (acc.dataset.bound) return;
      acc.dataset.bound = '1';
      var items = acc.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
    scope.querySelectorAll('[data-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if (!id) { window.location.href = '/collections/all'; return; }
        var qtyEl = document.querySelector('[data-qty-value]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        var old = btn.innerHTML;
        btn.innerHTML = 'Adding';
        btn.disabled = true;
        addToCart(id, qty, function (err) {
          btn.disabled = false;
          if (err) { btn.innerHTML = 'Try again'; setTimeout(function () { btn.innerHTML = old; }, 2000); return; }
          btn.innerHTML = 'Added';
          setTimeout(function () { window.location.href = '/cart'; }, 450);
        });
      });
    });
    scope.querySelectorAll('[data-qty]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var out = document.querySelector('[data-qty-value]');
        var input = document.querySelector('[data-qty-input]');
        if (!out) return;
        var v = parseInt(out.textContent, 10) || 1;
        v = btn.dataset.qty === 'up' ? v + 1 : Math.max(1, v - 1);
        out.textContent = v;
        if (input) input.value = v;
      });
    });
    var main = scope.querySelector('.gal-main');
    scope.querySelectorAll('.gal-thumbs .photo').forEach(function (t) {
      if (t.dataset.bound) return;
      t.dataset.bound = '1';
      t.addEventListener('click', function () {
        scope.querySelectorAll('.gal-thumbs .photo').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        if (main) main.style.setProperty('--img', getComputedStyle(t).getPropertyValue('--img'));
      });
    });
    document.querySelectorAll('.yr').forEach(function (e) { e.textContent = new Date().getFullYear(); });
  }

  function init(scope) {
    bind(scope);
    collectParallax(scope);
    initReveal(scope);
    paint();
    onScroll();
  }

  function boot() {
    if (!document.querySelector('.sprog')) {
      var b = document.createElement('div');
      b.className = 'sprog';
      document.body.appendChild(b);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    init(document);
    requestAnimationFrame(function () { document.body.classList.add('loaded'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  return { init: init, paint: paint, addToCart: addToCart };
})();


/* mobile nav submenus: delegated so it survives theme editor re-renders */
(function () {
  function collapseAll(except) {
    document.querySelectorAll('.has-sub.expanded').forEach(function (li) {
      if (li === except) return;
      li.classList.remove('expanded');
      var b = li.querySelector('.subtoggle');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.subtoggle');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    var li = t.closest('.has-sub');
    if (!li) return;
    var open = !li.classList.contains('expanded');
    collapseAll(li);
    li.classList.toggle('expanded', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, false);

  // closing the burger resets the submenus
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#burger')) {
      var hdr = document.querySelector('.hdr');
      if (hdr && !hdr.classList.contains('open')) collapseAll(null);
    }
  }, false);
})();


/* sticky buy bar reveals once the hero has scrolled past */
(function () {
  function boot() {
    var bar = document.querySelector('.stickybuy');
    var hero = document.querySelector('.hero');
    if (!bar) return;
    if (!hero) {
      // no hero on this page, reveal after a short scroll instead
      window.addEventListener('scroll', function () {
        bar.classList.toggle('show', window.scrollY > 320);
      }, { passive: true });
      return;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('show', !e.isIntersecting);
        });
      }, { rootMargin: '-70px 0px 0px 0px', threshold: 0 });
      io.observe(hero);
    } else {
      window.addEventListener('scroll', function () {
        bar.classList.toggle('show', window.scrollY > hero.offsetHeight - 70);
      }, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* The bar only steps aside when a real button is in the strip it would
   physically cover, not whenever one is anywhere on screen. */
(function () {
  function boot() {
    var bar = document.querySelector('.stickybuy');
    if (!bar || !('IntersectionObserver' in window)) return;

    var ctas = [].slice.call(document.querySelectorAll('a.btn, button.btn'))
      .filter(function (el) { return !bar.contains(el); });
    if (!ctas.length) return;

    var io = null;
    var onScreen = new Set();

    function build() {
      if (io) io.disconnect();
      onScreen.clear();
      // watch only the bottom strip of the viewport, roughly the bar's height
      var strip = bar.offsetHeight + 90;
      var top = Math.max(0, window.innerHeight - strip);
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) onScreen.add(e.target);
          else onScreen.delete(e.target);
        });
        bar.classList.toggle('mute', onScreen.size > 0);
      }, { threshold: 0, rootMargin: '-' + top + 'px 0px 0px 0px' });
      ctas.forEach(function (el) { io.observe(el); });
    }

    build();
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(build, 200);
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
